import { formDataFlat } from './form-data-flat';

export const object2Search = (query: Record<string, unknown>): string => {
  const flattened = formDataFlat<Record<string, string>>(query as Record<string, any>);
  const entries = Object.entries(flattened);
  return entries.length ? entries.reduce((acc, [key, value], index) => acc + (index ? '&' : '?') + `${key}=${value}`, '') : '';
};
